import { render, staticRenderFns } from "./ProjectSubMenu.vue?vue&type=template&id=519cac67&scoped=true&"
import script from "./ProjectSubMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSubMenu.vue?vue&type=style&index=0&id=519cac67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cac67",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuList: require('/workspace/components/Menu/SubMenus/Shared/MenuList.vue').default})
